import { BasicCategory } from 'src/api/v1-api/helpers';

export function getCategoryCountForTierGate(categories: BasicCategory[]) {
  return categories.filter(
    (category) =>
      category.functional?.create_listing_category_select_format !== 'pay_to_list_child',
  ).length;
}
